import { validatePlatformContent } from "utils/newMediaValidation";

/**
 * Validates YouTube post content and media
 * @param {Object} params - The parameters for validation
 * @param {String} params.title - The video title
 * @param {String} params.caption - The video description
 * @param {String} params.postType - The type of post (post, shorts)
 * @param {Array} params.mediaList - Media files for the post
 * @param {Boolean} params.made_for_kids - Whether the content is made for kids
 * @param {Number} params.monthlyPosts - Available monthly posts
 * @returns {Boolean} - Whether the post has validation errors
 */
const validateYoutube = ({
  title,
  caption,
  postType,
  mediaList,
  made_for_kids,
  monthlyPosts,
}) => {
  const errorList = [];

  const { platformErrors, mediaList: mediaListValidated } =
    validatePlatformContent({
      mediaListRaw: mediaList,
      platform: "youtube",
      postType,
      caption,
      title,
    });

  errorList.push(
    platformErrors.length > 0 ||
      mediaListValidated.some((media) => media.errors.length > 0)
  );
  errorList.push(typeof made_for_kids === "undefined");
  errorList.push(monthlyPosts < 1);

  return errorList.includes(true);
};

export default validateYoutube;
